class ReassuranceCarousel extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 1; // Commence sur le slide 2 (index 1)
    this.interval = null;
    this.initialized = false;
  }

  connectedCallback() {
    // Initialiser immédiatement si pas déjà fait
    if (!this.initialized) {
      // Utiliser requestAnimationFrame pour s'assurer que le DOM est prêt
      requestAnimationFrame(() => {
        this.init();
      });
    }
  }

  disconnectedCallback() {
    this.stopAutoPlay();
  }

  init() {
    if (this.initialized) {
      return;
    }

    this.slides = this.querySelectorAll('.reassurance-carousel__slide');
    this.dots = this.querySelectorAll('.reassurance-carousel__dot');

    if (this.slides.length === 0) {
      return;
    }

    this.initialized = true;

    // Afficher le slide initial
    this.showSlide(this.currentSlide);

    // Ajouter les event listeners sur les dots
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.goToSlide(index);
        return false;
      });
    });

    // Auto-play toutes les 1.5 secondes
    this.startAutoPlay();

    // Pause au survol
    this.addEventListener('mouseenter', () => {
      this.stopAutoPlay();
    });
    this.addEventListener('mouseleave', () => {
      this.startAutoPlay();
    });
  }

  showSlide(index) {
    if (!this.slides || this.slides.length === 0) {
      return;
    }

    // Masquer tous les slides
    this.slides.forEach((slide) => {
      slide.classList.remove('active');
    });

    // Afficher le slide actuel
    if (this.slides[index]) {
      this.slides[index].classList.add('active');
    }

    // Mettre à jour les dots
    if (this.dots) {
      this.dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('reassurance-carousel__dot--active');
        } else {
          dot.classList.remove('reassurance-carousel__dot--active');
        }
      });
    }

    this.currentSlide = index;
  }

  goToSlide(index) {
    this.showSlide(index);
    this.stopAutoPlay();
    // Redémarrer après un court délai
    setTimeout(() => {
      this.startAutoPlay();
    }, 100);
  }

  nextSlide() {
    if (!this.slides || this.slides.length === 0) {
      return;
    }
    const next = (this.currentSlide + 1) % this.slides.length;
    this.showSlide(next);
  }

  startAutoPlay() {
    this.stopAutoPlay();
    if (!this.slides || this.slides.length === 0) {
      return;
    }

    this.interval = setInterval(() => {
      this.nextSlide();
    }, 1500);
  }

  stopAutoPlay() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}

// Définir le custom element
if (!customElements.get('reassurance-carousel')) {
  customElements.define('reassurance-carousel', ReassuranceCarousel);
}

// Initialiser le carrousel quand le mini-cart est ouvert
function initReassuranceCarousel() {
  const carousel = document.querySelector('reassurance-carousel');
  if (carousel) {
    // Réinitialiser si nécessaire
    if (carousel.initialized) {
      carousel.stopAutoPlay();
      carousel.initialized = false;
    }
    // Initialiser directement si pas encore fait
    if (!carousel.initialized) {
      carousel.init();
    }
  }
}

// Écouter l'événement de chargement du cart drawer
document.addEventListener('cartdrawer:opened', () => {
  // Utiliser requestAnimationFrame pour une initialisation plus rapide
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      initReassuranceCarousel();
    });
  });
});

// Initialiser aussi au chargement de la page (au cas où le mini-cart serait déjà ouvert)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initReassuranceCarousel();
      });
    });
  });
} else {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      initReassuranceCarousel();
    });
  });
}
